import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';

function HighlightItem({ highlight, handleClickHighlight, handleDuplicateHighlight }) {
  return (
    <div className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100  h-44 ">
      <div
        className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44"
        onClick={handleClickHighlight}>
        <img
          className="h-32 w-32 object-cover shadow-md block rounded-md"
          src={highlight.image ? highlight.image.file : getImage('img-ph.png')}
          alt={highlight.image ? highlight.image.label : 'Non renseignée'}
        />
        <div className="flex flex-col justify-around h-full w-full">
          <div className="flex flex-col gap-y-1">
            <div className="text-xl font-bold text-slate-700 ">{highlight.title}</div>
          </div>
          <div className="flex flex-row gap-x-3">
            <Tag
              tag={{
                label: getConstant('shared.draftTypes', highlight.is_draft).label,
                bgColor: getConstant('shared.draftTypes', highlight.is_draft).bgColor
              }}
            />
            <Tag
              tag={{
                label: getConstant('quatrebis.highlightType', highlight.type).label,
                icon: 'star',
                bgColor: 'bg-sky-950'
              }}
            />
          </div>
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className="h-12 w-12"
        tooltip="Dupliquer le temps fort / Alumni"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateHighlight}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default HighlightItem;
